import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'
import Auth from './Auth';
import history from '../history';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';
import jquery from 'jquery';
import * as extra from '../extra';

export default class EconForm2 extends React.Component {

    constructor(props) {
        super(props);

        this.inputFio = this.inputFio.bind(this);
        this.submit = this.submit.bind(this);
        this.clearForm = this.clearForm.bind(this);

        this.state = {
            fio: '',
            listFioIsLoaded: false,
            listFio: [],
            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            status: ''
        };
    };

    inputFio(e){
        this.setState({
            fio: e.target.value
        })
    }

    clearForm(){
      this.setState({
        fio: '',
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        status: ''
      })
    }

    showStatus(text, time){
      this.setState({
        status: text
      })
      setTimeout(() => {
        this.setState({
          status: ''
        })
      }, time)
    }

    submit(){
        let data = {
            "id_form": 2,
            "fio" : this.state.fio,
            "input3" : this.state.input3,
            "input4" : this.state.input4,
            "input5" : this.state.input5
        }
        let res = extra.api('pushEconToServer', data);
        console.log(res);
        this.clearForm();
        if( (res > -1) && (res !== '') ){
          this.showStatus('Данные успешно добавлены', 3000);
        } else {
          this.showStatus('Ошибка! данные не были добавлены', 3000);
        }
    }

    componentWillMount(){

      //получение списка ФИО
      let list_1 = extra.api('getListFioByIdGroup', 3);
      //console.log(list_1);
      list_1 = JSON.parse(list_1);
      list_1.pop();
      let list_2 = extra.api('getListFioByIdGroup', 5);
      //console.log(list_2);
      list_2 = JSON.parse(list_2);
      list_2.pop();
      let list = list_1.concat(list_2);
//let list = ['324324','edsfdsf','dsfdsfdsf','dsfdsf'];
      this.setState({
          listFioIsLoaded: true,
          listFio: list
      });
    }

    render() {
            return (
            <div className='econform2'>

            <div className='status-block'>{this.state.status}</div>

              <div className='fio-block'>
                <div className='title'>ФИО ППС</div>
                <Autocomplete
                    items={this.state.listFio}
                    shouldItemRender={(item, value) => item.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item}
                    renderItem={(item, highlighted) =>
                      <div
                        key={item.id}
                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}
                      >
                        {item}
                      </div>
                    }
                    value={this.state.fio}
                    onChange={e => this.setState({ fio: e.target.value })}
                    onSelect={value => this.setState({ fio: value })}
                />
              </div>

              <div className='input-3-block'>
                  <div className='title'>Среднемесячный доход в рамках НИР:</div>
                  <input
                      onChange={e => this.setState({ input3: e.target.value })}
                      value={this.state.input3}
                      type='number'
                  />
              </div>

              <div className='input-4-block'>
                  <div className='title'>Среднемесячный доход в рамках выполнения грантов:</div>
                  <input
                      onChange={e => this.setState({ input4: e.target.value })}
                      value={this.state.input4}
                      type='number'
                  />
              </div>

              <div className='input-5-block'>
                  <div className='title'>Количество  НПР (приведенных к полной ставке):</div>
                  <input
                      onChange={e => this.setState({ input5: e.target.value })}
                      value={this.state.input5}
                      type='number'
                  />
              </div>

              <div className='submit-button' onClick={this.submit}>Отправить</div>

            </div>
            );
    }
}



// WEBPACK FOOTER //
// ./src/component/EconForm2.js